import { useNavigate } from "react-router-dom";
import { Dropdown, Avatar } from "rsuite";
import { useUserMutation } from "./useUserMutation";
import { Flex, useAuthenticator } from "@aws-amplify/ui-react";
import { useAuth } from "../../ui-components/utils";
import { useProfileQuery } from "../profile/api/useProfileQuery";
import { useUserQuery } from "./useUserQuery";
import { useTheme } from "@aws-amplify/ui-react";

export default function () {
  const { tokens } = useTheme();
  const { signOut, user } = useAuthenticator((context) => [context.user]);
  const navigate = useNavigate();
  const { mutate: userMutate } = useUserMutation();
  const authAttributes = useAuth().user?.attributes ?? {};
  const { data: activeProfile } = useUserQuery();
  const { data: sessionUser, isLoading } = useProfileQuery(user?.userId);
  return (
    <Dropdown
      renderToggle={(props) => (
        <Flex
          justifyContent={"center"}
          alignContent={"center"}
          alignItems={"center"}
        >
          <Avatar
            circle
            style={{ background: `${tokens.colors.primary[60]}` }}
            {...props}
          />
        </Flex>
      )}
      placement="leftStart"
    >
      <Dropdown.Item
        panel
        style={{ paddingLeft: 10, paddingRight: 10, width: 160 }}
      >
        <p>Signed in as</p>
        <strong>
          {sessionUser?.givenName
            ? sessionUser?.givenName
            : authAttributes["given_name"]}
        </strong>
      </Dropdown.Item>
      {activeProfile?.isAdvocating === true && (
        <Dropdown.Item panel style={{ padding: 10, width: 160 }}>
          <p>Advocating for</p>
          <strong>
            {activeProfile?.nickname
              ? `${activeProfile?.nickname}`
              : activeProfile?.givenName}
          </strong>
        </Dropdown.Item>
      )}
      <Dropdown.Separator />
      <Dropdown.Item onClick={() => navigate("/user/hr/switch-profile")}>
        Switch profile
      </Dropdown.Item>
      <Dropdown.Item onClick={() => navigate("/user/hr/minor-dependents/add")}>
        Add minor dependent
      </Dropdown.Item>
      <Dropdown.Item onClick={() => navigate("/user/profile/about-me")}>
        Update my profile
      </Dropdown.Item>
      <Dropdown.Separator />
      <Dropdown.Item onClick={() => navigate("/user/profile/general")}>
        Communication Preference
      </Dropdown.Item>
      <Dropdown.Item onClick={() => navigate("/user/profile/settings")}>
        Settings
      </Dropdown.Item>
      <Dropdown.Separator />
      <Dropdown.Item
        onClick={() => {
          sessionStorage.clear();
          userMutate({ patientUserId: undefined, isAdvocating: false });
          signOut();
          window.location.href = "/";
        }}
      >
        Sign out
      </Dropdown.Item>
    </Dropdown>
  );
}
